module.exports = __webpack_public_path__ + "img/treppengelaender.95102285.webp";